import { render } from "./LocalLiveSqlContent.vue?vue&type=template&id=32966fb0"
import script from "./LocalLiveSqlContent.vue?vue&type=script&lang=js"
export * from "./LocalLiveSqlContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__